import { createFileRoute } from "@tanstack/react-router";
import { ServiceAccounts } from "../../../features/settings/service-accounts";

export const Route = createFileRoute("/_authed/$org/$project/serviceaccounts/")({ component: ServiceAccountsPage });

function ServiceAccountsPage() {
  const { org, project } = Route.useParams();
  return <ServiceAccounts org={org} project={project} />;
}
